const config = {
    build_number: '617422',
    build_timestamp: '2026-10-22T19:17:57.628Z',
    build_commit: '56ac0a8d287266e63c072e21147ed2a05de2b8a1',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
